module.exports = __webpack_public_path__ + "img/about1.47b987c2.jpg";